import BlockImageCard from './BlockImageCard';
export default BlockImageCard;